/**
 * Les devises et fuseaux que l'assistant d'ouverture propose. La liste couvre
 * le marché de la plateforme ; une valeur déjà saisie hors liste reste
 * proposée, pour ne jamais la perdre en rouvrant le dossier.
 */
const DEVISES = ['EUR', 'GBP', 'CHF', 'USD'] as const;
const FUSEAUX = [
  'Europe/Paris',
  'Europe/Brussels',
  'Europe/Luxembourg',
  'Europe/Zurich',
  'Europe/London',
  'America/New_York',
] as const;

function avec(liste: readonly string[], courante: string): string[] {
  return courante !== '' && !liste.includes(courante) ? [courante, ...liste] : [...liste];
}

export const devisesProposees = (courante: string): string[] => avec(DEVISES, courante);
export const fuseauxProposes = (courant: string): string[] => avec(FUSEAUX, courant);
